/**
 * @file   index.js 拉新活动 H5
 * @author chengyuan06<chengyuan06@baidu.com>
 * @date   2020-11-02
 */
import app from '@app';
import {Component} from 'san';
import './index.scss';
import 'swiper/dist/css/swiper.css';
import Swiper from 'swiper';
import isBox from '@baidu/xbox/is-box';
import copy2clipboard from '@utils/copy2clipboard';
import openShare from '@baidu/xbox-native/ui/openShare';
import Toast from '@utils/toast';
import {sendLog} from '@utils/log';
import filter from '@utils/filter';
import {isIOS} from '@baidu/xbox/os';
import {invokeApp} from '@baidu/xbox-vertical-na/openBox';
import {openAppSwanPage} from '@utils/open-app';
import url from '@utils/url';
import network from '@utils/network';
import api from '@config/api';
import {PAGE} from '@config/index';
import {PAGE_FROM_SWAN} from '@const/index';

const PAGE_PARAMS = url.parse().params;
const NEW_CHANNEL_NUMBER = PAGE_PARAMS.newCN;
const INVOKE_CHANNEL_NUMBER = PAGE_PARAMS.invokeCN;
const FROM = PAGE_PARAMS.from;
const HOME_DOWNLOAD = PAGE_PARAMS.homeDownload;

export default class AppComponent extends Component {
    constructor(opts) {
        super(opts);
    }

    static template = `
        <div class="pull-user-activity {{mashHidden}}">
            <div class="head">
                <div class="head-bg-img" >
                    <img src="https://gemapp.cdn.bcebos.com/pic/wbemr3fyf79ce55ca35b7023"/>
                </div>
                <div class="log-buble-container">
                    <div class="log-container">
                        <img src="https://gemapp.cdn.bcebos.com/pic/chs0ihev2c95507c048b3576" />
                    </div>
                    <!-- 气泡部分 -->
                    <div class="swiper-container-bubble" s-if="isActvTime == 1">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" s-for="item in bubbleList">
                                <div class="bubble">
                                    <div class="text ellipsis">{{item.msg}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--新人专享-->
            <div class="new-user-container">
                <div class="streamer" s-if="isActvTime == 1">
                    <span class="streamer-content">*新人专享每人限抢1件，每天中午12点补货上新</span>
                </div>
                <div class="list">
                    <div class="item" s-if="isActvTime == 1" s-for="item in newUserList" on-click="openApp2Activity">
                        <div class="img-container">
                            <img src="{{item.cover.url}}">
                        </div>
                        <div class="content-container">
                            <div class="title">
                                <img class="icon" src="https://gemapp.cdn.bcebos.com/pic/i1euz0gb3066af44fc4bb2f9" />
                                {{item.title}}
                            </div>
                            <div class="info-container">
                                <img s-if="item.freeMail == 1" src="https://gemapp.cdn.bcebos.com/pic/zikheaxi268b2afb713fc58c" />
                            </div>
                            <div class="price-container">
                                <div class="icon">¥</div>
                                <div class="curr-price">{{item.freeManPrice | getPriceNum}}</div>
                                <div class="old-price" s-if="item.price && (item.price > item.freeManPrice)">
                                    {{item.price | getPriceNum}}
                                </div>
                                <img s-if="item.isValid" src="https://gemapp.cdn.bcebos.com/pic/6hgmrbvh11eaecadd9c13362" />
                                <img s-else src="https://gemapp.cdn.bcebos.com/pic/fczce2va92e05d90cc5feb04" />
                            </div>
                        </div>
                    </div>
                    <!--下线商品展示-->
                    <div class="item down" s-else>
                        <div class="content-container">
                            <div class="down-text">很遗憾，活动已下线～</div>
                            <div class="go-app" on-click="navigateToApp">去古物潮玩 查看更多好货
                                <span s-if="timeOutRedirectTimer">{{timeOut}}s</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--捡漏榜-->
            <div class="cheap-list-container" s-if="cheapList.length > 0">
                <div class="cheap-img">
                    <img src="https://gemapp.cdn.bcebos.com/pic/55tmih8ff6837d750b467791" />
                </div>
                <div class="cheap-list">
                    <div class="cheap-item" s-for="item in cheapList" on-click="openApp2GoodsDetail">
                        <img class="cheap-bg" src="https://gemapp.cdn.bcebos.com/pic/bha6p17h6dfa788e9c179671" />
                        <div class="head-img">
                            <img src="{{item.cover.url}}" />
                        </div>
                        <div class="info-container">
                            {{item.title}}
                        </div>
                        <div class="app-price">APP专享价</div>
                        <img class="free-mail" s-if="item.freeMail == 1" src="https://gemapp.cdn.bcebos.com/pic/i7kcp9si5f0b87c79640f0ae" />
                        <div class="bottom-price-container">
                            <div class="bond-price">
                                券后<span class="icon">¥</span>
                                <span class="price-num">{{item.couponPrice | getPriceNum}}</span>
                            </div>
                            <div
                                class="normal-price"
                                s-if="item.originalPrice && (item.originalPrice > item.couponPrice)">
                                ￥{{item.originalPrice | getPriceNum}}
                            </div>
                        </div>
                    </div>
                </div>
                <div s-if="isActvTime" class="bottom-container" on-click="openAppBottomBtn">
                    <div class="bottom-btn">去古物潮玩&nbsp;更多捡漏好货</div>
                </div>
            </div>
            <!--悬浮标-->
            <div class="popup-icon" on-click="share" >
                <img src="https://gemapp.cdn.bcebos.com/pic/uibpusb831371d07f577e8c8" />
            </div>
            <!--分享面板-->
            <div class="share-panel {{sharePanelIsShow}}" on-touchmove="preventTouchmove">
                <div class="title">
                    <div class="title1">壕礼分享给亲友</div>
                    <div class="title2">数量有限，先到先得</div>
                </div>
                <div class="share-goods-list">
                    <div class="item" s-for="item in shareGoodsList">
                        <img src="{{item.cover.url}}" />
                        <div class="new-user-icon">新人专享</div>
                        <div class="price-container">
                            <span class="price-icon">¥</span>
                            <span class="price">{{item.freeManPrice | getPriceNum}}</span>
                        </div>
                        <span class="number">限量10件</span>
                        <div class="shadow-continer"></div>
                    </div>
                </div>
                <div class="link-container">
                    <div class="link" id="link">{{copyLink}}</div>
                    <div class="copy-btn" on-click="copyLink" >复制链接</div>
                </div>
                <div class="step-container">
                    <div class="step-one">第一步：复制链接<span class="already-copy">已复制</span></div>
                    <div class="step-two">第二步：打开微信 / QQ / 微博，粘贴发送给亲友</div>
                </div>
                <hr class="line" />
                <div class="cancel" on-click="cancelShare">取消</div>
            </div>
            <!--活动规则-->
            <div class="activity-rule" on-click="showActivityRule" >
                <div class="inner">活动规则</div>
            </div>
            <div class="activity-rule-container" s-if="activityRuleIsShow">
                <div class="title">活动规则</div>
                <div class="content">
                    活动时间：{{activityTime}}<br/>
                    <br/>
                    活动说明：新人豪礼活动仅限从未在古物潮玩平台下单的新用户参加，满足活动条件用户下载并打开app领取优惠券，即可按新人专享价购买；新人专享商品数目有限，先到先得，售完即止。<br/>
                    <br/>
                    价格说明：商品显示价格为劵后价格，支付时自动抵扣优惠券；划线价为商品售价。<br/>
                    <br/>
                    优惠券使用规则<br/>
                    1、每个用户在本次活动中只能领取一次优惠券，若已领取，不会再次发放；每天券数量有限，先到先得，领完即止;<br/>
                    2、获得的优惠券仅供本人在【古物潮玩APP】内购买商品时抵用;<br/>
                    3、平台优惠券全场通用，店铺优惠券仅限对应店铺内购买商品时使用;<br/>
                    4、优惠券不能兑换现金，不可转让，每张优惠券仅能使用一次，不可叠加使用，不找零，不退换;<br/>
                    5、使用优惠券抵扣部分的金额不开具发票;<br/>
                    6、使用优惠券提交的订单，在订单未支付时取消订单，则订单取消后，系统自动返还相应的优惠券;<br/>
                    7、优惠券请在系统显示的有效期内使用，逾期作废;<br/>
                    8、优惠券使用需满足消费门槛要求;<br/>
                    9、若违反优惠券使用规则，包括但不限于一名用户注册多个账号、
                    一个账号领取多份优惠券、非真实用户领取优惠券的，
                    古物潮玩有权视情况选择冻结或作废相关顾客持有的优惠券、
                    取消使用优惠券的订单、取消该用户的用券资格等行为;<br/>
                    10、本规则由古物潮玩依据国家相关法律法规及规章制度予以解释。
                </div>
                <div class="close" on-click="closeActivityRule"></div>
            </div>
            <!-- 蒙层 -->
            <div class="mask" s-if="maskVisible" on-touchmove="closeMask"></div>
            <!-- 任务中心定制toast -->
            <div class="baidu-task-toast" s-if="baiduTaskToastVisible">
                <div class="text">{{baiduTaskToastMsg}}</div>
                <div class="btn" on-click="toBdTaskCenter">{{baiduTaskToastBtnText}}</div>
            </div>
        </div>
    `;

    initData() {
        let data = window.INITIAL_DATA.data;
        return {
            newUserList: data.freeManProduct,
            cheapList: data.plugProduct,
            shareGoodsList: this.initShareList(data),
            isActvTime: data.isActvTime,
            bubbleList: data.msgList,
            downloadLinks: data.downloadLinks,
            activityTime: data.time,
            timeOut: 5,
            sharePanelIsShow: 'hidden',
            activityRuleIsShow: false,
            copyLink: window.location.href,
            maskVisible: false,
            mashHidden: '',
            baiduTaskToastVisible: '',
            baiduTaskToastMsg: '',
            baiduTaskToastBtnText: '',
            baiduTaskToastDuration: '',
            baiduTaskToastScheme: '',
            timeOutRedirectTimer: null
        };
    }

    attached() {
        if (this.data.get('isActvTime') === 0) {
            this.timeOutRedirect();
        }
        this.bubbleSwiper();
        sendLog('pv', {
            ext: {
                'activity_status': this.data.get('isActvTime')
            }
        });
    }

    static filters = {
        getPriceNum: filter.getPriceNum
    };

    // 活动下线时没有新人豪礼的商品，用捡漏榜的前三个商品去填充分享面板的数据
    initShareList(data) {
        if (data.isActvTime === 1) {
            return data.freeManProduct.slice(0, 3);
        }
        let temp = data.plugProduct.slice(0, 3);
        let result = temp.map(item => {
            item.freeManPrice = item.price;
            return item;
        });
        return result;

    }

    // 点击蒙层去掉掉蒙层
    closeMask(event) {
        event.preventDefault();
    }
    toBdTaskCenter() {
        invokeApp({
            scheme: this.data.get('baiduTaskToastScheme'),
            failCb: () => {}
        });
    }
    // 点击底部去活动页面
    openAppBottomBtn() {
        sendLog('clk', {
            value: 'openappbottombtn',
            ext: {
                'activity_status': this.data.get('isActvTime')
            }
        });
        this.invokeAppToActivity();
    }

    // 气泡初始化
    bubbleSwiper() {
        new Swiper('.swiper-container-bubble', {
            loop: true,
            speed: 500,
            slidesPerView: 1,
            direction: 'vertical',
            autoplay: 1000
        });
    }

    // 禁止页面滑动
    preventTouchmove(event) {
        this.data.set('mashHidden', 'mask-hidden');
        event.preventDefault();
    }

    // 活动下线点击去app查看更多
    navigateToApp() {
        sendLog('clk', {
            value: 'viewmoregoods',
            ext: {
                'activity_status': this.data.get('isActvTime')
            }
        });
        window.location.href = 'http://www.guwuchaowan.com';
    }

    // 活动下线倒计时跳转
    timeOutRedirect() {
        const timer = setInterval(() => {
            if (this.data.get('timeOut') > 0) {
                this.data.set('timeOut', this.data.get('timeOut') - 1);
            }
            else {
                this.navigateToApp();
            }
        }, 1000);
        this.data.set('timeOutRedirectTimer', timer);
    }

    openApp() {
        let path = '/pkg-activity/pages/get-user-activity/index?channel=gemh5';

        // 透传宝宝知道任务中心携带的任务token
        if (PAGE_PARAMS.baobaoToken) {
            path += `&baobaoToken=${PAGE_PARAMS.baobaoToken}`;
        }

        openAppSwanPage(
            {path},
            {
                useCopy: true,
                newCN: NEW_CHANNEL_NUMBER,
                invokeCN: INVOKE_CHANNEL_NUMBER,
                fail: () => {
                    const flag = (HOME_DOWNLOAD || FROM === PAGE_FROM_SWAN) && !isIOS();
                    if (flag) {
                        let params = '?invokeCN=' + INVOKE_CHANNEL_NUMBER + '&newCN=' + NEW_CHANNEL_NUMBER;
                        location.href = PAGE.home + params;
                    }
                    // 非小程序内banner或ios执行默认逻辑，小程序内安卓不执行
                    return !flag;
                }
            }
        );
    }

    invokeAppToActivity() {
        // 接入手百任务中心
        if (isBox() && PAGE_PARAMS.sourceForm === 'jifenshangcheng') {
            // 请求手百任务中心接口
            network.get(api.pullUserActivity.baiduTask).then(response => {
                let data = response.data.data;
                if (data.errno === 0) {
                    this.data.set('baiduTaskToastVisible', true);
                    this.data.set('baiduTaskToastMsg', data.message);
                    this.data.set('baiduTaskToastBtnText', data.btnText);
                    this.data.set('baiduTaskToastDuration', data.toastDuration);
                    this.data.set('baiduTaskToastScheme', data.schema);
                    setTimeout(() => {
                        this.data.set('baiduTaskToastVisible', false);
                    }, (data.toastDuration || 0) * 1000);
                    setTimeout(() => {
                        this.openApp();
                    }, 0);
                }
                else {
                    this.openApp();
                }
            }).catch(() => {
                this.openApp();
            });
        }
        else {
            this.openApp();
        }
    }

    // 点击新人专享打开对应活动页
    openApp2Activity() {
        sendLog('clk', {
            value: 'welfarecard',
            ext: {
                'activity_status': this.data.get('isActvTime')
            }
        });
        this.invokeAppToActivity();
    }

    // 点击捡漏榜卡片埋点
    openApp2GoodsDetail() {
        sendLog('clk', {
            value: 'relatecard',
            ext: {
                'activity_status': this.data.get('isActvTime')
            }
        });
        clearInterval(this.data.get('timeOutRedirectTimer'));
        this.data.set('timeOutRedirectTimer', null);
        this.invokeAppToActivity();
    }

    // 复制链接
    copyLink() {
        sendLog('clk', {
            value: 'copylink',
            ext: {
                'activity_status': this.data.get('isActvTime')
            }
        });
        copy2clipboard(this.data.get('copyLink'), () => {
            Toast.init();
            Toast.show('复制成功', 2000);
        });
    }

    // 显示活动规则
    showActivityRule() {
        sendLog('clk', {
            value: 'rule',
            ext: {
                'activity_status': this.data.get('isActvTime')
            }
        });
        this.data.set('activityRuleIsShow', true);
        this.data.set('maskVisible', true);
        this.data.set('mashHidden', 'mask-hidden');
    }

    // 隐藏活动规则
    closeActivityRule() {
        this.data.set('activityRuleIsShow', false);
        this.data.set('maskVisible', false);
        this.data.set('mashHidden', '');
    }

    // 隐藏分享面板
    cancelShare() {
        this.data.set('sharePanelIsShow', 'hidden');
        this.data.set('maskVisible', false);
        this.data.set('mashHidden', '');
    }
    // 点击送壕礼悬浮图标
    share() {
        sendLog('clk', {
            value: 'share',
            ext: {
                'activity_status': this.data.get('isActvTime')
            }
        });
        this.data.set('maskVisible', true);
        if (isBox() && (isIOS() === false)) {
            // 手百端内唤起分享面板,手百内分享不用遮罩层
            this.data.set('maskVisible', false);
            openShare({
                name: 'utils-shareBox',
                data: {
                    mediaType: 'all',
                    title: '朋友送你一份豪礼,快来看看!',
                    content: '古物潮玩文玩好货千万补贴中,抢到就是赚到',
                    iconUrl: 'https://gemapp.cdn.bcebos.com/pic/rhefctqsc8f0acb1ecfc03ea',
                    linkUrl: window.location.href,
                    type: 'url',
                    source: 'guwuchaowan'
                }
            });
        }
        else {
            // 手百外展示自己写的分享面板
            this.data.set('sharePanelIsShow', '');
            this.copyLink();
        }
    }
}

app(AppComponent, '#app');
